module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero14.png?7aec91bc";